import { render } from "./GraduationRatesByProgram.vue?vue&type=template&id=92058e94&scoped=true"
import script from "./GraduationRatesByProgram.vue?vue&type=script&lang=js"
export * from "./GraduationRatesByProgram.vue?vue&type=script&lang=js"

import "./GraduationRatesByProgram.vue?vue&type=style&index=0&id=92058e94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-92058e94"

export default script